module.exports = __webpack_public_path__ + "img/elandmall.e08a9ff3.png";